export default __webpack_public_path__ + "815809e68382d62a496cca54446607a9.webp";